import { useRef } from 'react'
import TagManager from 'react-gtm-module'

type Result = {
  logEvent: (event: string, data?: Record<string, unknown>) => void
  setUserId: (userId: string, email: string) => void
}

/** Triggers tag manager events using Google Tag Manager */
const useAnalytics = (): Result => {
  // These event types have been setup in GTM such that they're logged both into GA and Amplitude. Amplitude events
  // are required to have the eventType field, and the eventProperties field for sending in event parameters
  const logEvent = useRef((eventType: string, data?: Record<string, unknown>) =>
    TagManager.dataLayer({
      dataLayer: {
        event: 'logEvent',
        eventType,
        eventProperties: { ...data, url: window.location.href },
      },
    }),
  ).current

  // Configured through GTM to call the Amplitude setUserId
  const setUserId = useRef((userId: string, email: string) =>
    TagManager.dataLayer({
      dataLayer: {
        event: 'setUserId',
        email,
        userId,
      },
    }),
  ).current

  return {
    logEvent,
    setUserId,
  }
}

export default useAnalytics
